import React from 'react';

interface Props{}
const PuppyTravelContainer: React.FC<Props> = ({}) => {

  return (
    <div className="dog-travel template">
        <article className="template-circle-header about-us-travel__header template-circle-header--secondary">
            <div className="template-circle-header__content">
                <div className="template-circle-header__content-copy">
                    <h1 className="template-element-title--header promise" style={{margin: '1.5rem 0'}}>
                        We Deliver Joy
                    </h1>
                    <p style={{margin: '1.2rem 0'}}><strong><span data-contrast="none" className="TextRun MacChromeBold SCXW230242172 BCX0"><span className="NormalTextRun SCXW230242172 BCX0">Our puppies are delivered by people who love your puppy as much as you do</span></span></strong><span data-contrast="none" className="TextRun SCXW230242172 BCX0"><span className="NormalTextRun SCXW230242172 BCX0"><strong>.</strong> At </span><span className="NormalTextRun SpellingErrorV2Themed SCXW230242172 BCX0">PuppySpot</span><span className="NormalTextRun SCXW230242172 BCX0">, we understand traveling can be scary for </span><span className="NormalTextRun ContextualSpellingAndGrammarErrorV2Themed SCXW230242172 BCX0">first-timers</span><span className="NormalTextRun SCXW230242172 BCX0">, whether they walk on two legs or four. Our dedicated team and travel partners always put the health and wellbeing of your puppy first, making sure he or she arrives safely.</span></span></p>
                                                        </div>
                <picture className="">
                            <img id="" alt="" className=" template-circle-header__image lazyloading" data-cy="" data-src="" loading="lazy"/>
                </picture>

            </div>
        </article>
                <article className="about-navigation">
            <a className="" href="/promise">PuppySpot Promise</a>
            <a className="" href="/reviews">Customer Reviews</a>
            <a className="" href="/puppyspot-standards">Breeder Standards</a>
            <a className="" href="/health-check">Health Check</a>
            <a className="active" href="/dog-travel">Travel Options</a>
            <a className="" href="/gives-back">PuppySpot Gives Back</a>
        </article>
                <section className="dog-travel__transportation-network">
                    <article>
                        <h2>PuppySpot oversees various trusted, USDA-certified transportation programs</h2>
                        <div className="dog-travel__transportation-network-content">
                                                    <img src="https://cdn.buttercms.com/nHlEJ2M8Rr6Wi08Qpd2v" alt="PuppySpot oversees various trusted, USDA-certified transportation programs"/>
                                                <p>Whether your puppy travels on a commercial airline, in cabin with one of our trained Chaperones, or along one of our select ground routes, all of our puppies travel under USDA-guidelines for proper animal care, and according to PuppySpot time limits.</p>
        <p>Simply put, each travel program is designed to put the health and welfare of your puppy first. If you wish to pick up your new puppy yourself, we can provide advice on how best to do that.</p>
                        </div>
                    </article>
                </section>
                <article className="template-gallery about-us-travel__">
                    <div style={{backgroundImage: "url('https://cdn.buttercms.com/QpiyS5WSEKleE5fKswoc')"}} className="template-gallery__image image-top"></div>
                    <div style={{backgroundImage: "url('https://cdn.buttercms.com/9ZLqc9YiQHmPc2xLpu6W')"}} className="template-gallery__image image-bottom"></div>
                    <div style={{backgroundImage: "url('https://cdn.buttercms.com/xlQDy5GfQxSS81k0JsCK')"}} className="template-gallery__image large-image"></div>
            </article>
                <hgroup>
                    <h2>Our transportation programs ensure the health, comfort, quality, and communication from the breeder’s doorstep to that first wet-nose moment.</h2>
                    <h3></h3>
                </hgroup>
                <article className="template-icon-grid template-icon-grid--about-us-travel about-us-travel__options">
                    <div className="template-icon-grid__card">
                    <picture className="">
                            <img id="" alt="" className="lazyload " data-cy="" data-src="https://cdn.buttercms.com/C8W6lRKSeenROMGu4ekw" loading="lazy"/>
                </picture>

                    <div className="template-icon-grid__card-copy">
                        <h3 id="template-icon-grid__near-home">
                            Breeder Meet Up
                        </h3>
                        <div role="definition" aria-labelledby="template-icon-grid__near-home">
                            <p>Meet the breeder and your puppy at a location near the kennel. (Not available on all Puppies)&nbsp; &nbsp; &nbsp; &nbsp;</p>
        <p>This program is <strong>$200</strong>, which includes:&nbsp;&nbsp;</p>
        <ul>
        <li>In person meet up with the breeder</li>
        <li>Your puppy's health certificate</li>
        </ul>
        <p>Please remember to bring: &nbsp;&nbsp;</p>
        <ul>
        <li>A travel carrier, leash and collar</li>
        <li>Food, water, and Nutri-Cal&nbsp; &nbsp; &nbsp; &nbsp;</li>
        <li>Cleaning supplies and a toy from your Starter Kit</li>
        </ul>
        <p><span data-contrast="none">If you are flying to meet your puppy, please coordinate with your airline to determine their specific requirements for transporting your new puppy back home. If you are driving, you can </span><a href="/resource-center/travel/traveling-with-your-new-puppy" rel="follow"><b><span data-contrast="none">click here for more info</span></b></a><span data-contrast="none"> on traveling with your puppy.   </span></p>
                        </div>
                    </div>
                </div>
                    <div className="template-icon-grid__card">
                    <picture className="">
                            <img id="" alt="" className="lazyload " data-cy="" data-src="https://cdn.buttercms.com/REPdSlLTi8MAXfzH6zAC" loading="lazy" />
                </picture>

                    <div className="template-icon-grid__card-copy">
                        <h3 id="template-icon-grid__door">
                            Deliver Near Your Home
                        </h3>
                        <div role="definition" aria-labelledby="template-icon-grid__door">
                            <p><span data-contrast="none" className="TextRun SCXW152582833 BCX0"><span className="NormalTextRun SpellingErrorV2Themed SCXW152582833 BCX0">PuppySpot works with trusted licensed professionals in the commercial air and ground transportation puppy travel business to get your puppy to an airport or one of our pickup locations as close to your home as possible. &nbsp;Once you’ve completed payment for your puppy, our &nbsp;team will get to work determining the best possible way to travel your puppy from where they live to where you live. &nbsp;Keep in mind that both air and ground travel can be limited &nbsp;by many factors beyond weather, so we all need to be flexible with dates and times of your puppy’s arrival.</span></span></p>
        <p>This program is <strong>$799</strong>, which includes:&nbsp;</p>
        <ul>
        <li>Delivery&nbsp;</li>
        <li>Your puppy’s health certificate&nbsp;</li>
        </ul>
                        </div>
                    </div>
                </div>
                    <div className="template-icon-grid__card">
                    <picture className="">
                            <img id="" alt="" className="lazyload " data-cy="" data-src="https://cdn.buttercms.com/5NM5oaTZTlOUI4bWs7qd" loading="lazy"/>
                </picture>

                    <div className="template-icon-grid__card-copy">
                        <h3 id="template-icon-grid__chaperone">
                            Puppy Chaperone
                        </h3>
                        <div role="definition" aria-labelledby="template-icon-grid__chaperone">
                            <p><span data-contrast="none" className="TextRun SCXW87605594 BCX0"><span className="NormalTextRun SCXW87605594 BCX0">A Puppy Chaperone brings your puppy to an airport near you. A Puppy Chaperone is a human companion who accompanies your puppy in the cabin of the plane. The </span><span className="NormalTextRun SCXW87605594 BCX0">Puppy Chaperone will personally greet you at the airport to deliver your healthy puppy directly to you. </span><span className="NormalTextRun SCXW87605594 BCX0">Keep in mind that air travel can be limited due to weather anywhere along your puppy’s route, so we all need to be flexible with dates and times of arrival.</span></span><span className="EOP SCXW87605594 BCX0" data-ccp-props="{&quot;134233117&quot;:true,&quot;134233118&quot;:true,&quot;201341983&quot;:2,&quot;335559739&quot;:160,&quot;335559740&quot;:390}">&nbsp;</span></p>
        <p><br/>This program is <strong>$2,399</strong>&nbsp;which includes:</p>
        <ul>
        <li>Puppy Chaperone travel cost</li>
        <li>Your puppy's health certificate</li>
        <li>Travel carrier&nbsp;</li>
        </ul>
                        </div>
                    </div>
                </div>
                    <div className="template-icon-grid__card">
                    <picture className="">
                            <img id="" alt="" className="lazyload " data-cy="" data-src="https://cdn.buttercms.com/XgPfDdBeSBeugnsfR4xa" loading="lazy"/>
                </picture>

                    <div className="template-icon-grid__card-copy">
                        <h3 id="template-icon-grid__plane">
                            Weather, Heat, and Travel Information
                        </h3>
                        <div role="definition" aria-labelledby="template-icon-grid__plane">
                            <p><span>We try to get all our puppies home within </span><u>2-3 weeks</u><span>. To do so, the puppy will need to meet age, weight and health requirements before being authorized to travel. The Travel team will then choose the best travel method for each puppy and customer based on many factors, including breeder and customer location, puppy age, and size. </span><span>As soon as we know the best way to get your puppy home, you will be the first to know.</span></p>
        <p><span>Read more about how puppies travel on commercial airlines <a href="/resource-center/travel/how-puppies-travel-on-commercial-airlines-and-impacts-temperature-and-weather-can-have-on-their-sche" rel="follow">here</a>.</span></p>
                        </div>
                    </div>
                </div>
                <div className="template-icon-grid__blurb">

                    </div>
        </article>
    </div>
  );
}

export default PuppyTravelContainer;
